import { GET_ACCOUNT_RESTRICTION_REASONS, GET_COUNTRIES, GET_CUSTOMER_TYPES, GET_WALLET_RESTRICTION_TYPES } from "../../actions/constants";

const initialAuthState = {
	countries: [],
	customerTypes: [],
	restrictionTypes: [],
	restrictionReasons: [],
};

export const appSettingsReducer = (state = initialAuthState, action: any) => {
	switch (action.type) {
		case GET_COUNTRIES: {
			return {
				...state,
				countries: action.countries,
			};
		}
		case GET_CUSTOMER_TYPES: {
			return {
				...state,
				customerTypes: action.customerTypes,
			};
		}
		case GET_WALLET_RESTRICTION_TYPES: {
			return {
				...state,
				restrictionTypes: action.restrictionTypes,
			};
		}
		case GET_ACCOUNT_RESTRICTION_REASONS: {
			return {
				...state,
				restrictionReasons: action.restrictionReasons,
			};
		}
		default: {
			return state;
		}
	}
};

export default appSettingsReducer;
